enum RubricSection {
  relevantExperience = 'relevantExperience',
  relevantQualifications = 'relevantQualifications',
  relevantSkills = 'relevantSkills',
  softSkills = 'softSkills'
}

const rubricSections = [
  { title: 'Relevant experience', id: RubricSection.relevantExperience },
  {
    title: 'Relevant qualifications',
    id: RubricSection.relevantQualifications
  },
  { title: 'Technical skills', id: RubricSection.relevantSkills },
  { title: 'Soft skills (predicted)', id: RubricSection.softSkills }
];

export { RubricSection, rubricSections };
